<ng-container *transloco="let t;">
<div class="col-12 col-lg-8 col-md-8 p-2 bulkUpload-rightColumn-border">

    <h3 class="title-heading-text">{{t('Step title (import summary step) - Imported Files')}}</h3>

    <div class="col-12 col-lg-12 col-md-12 p-0">
        <div class="table-responsive minHeightForTable">
            <app-table
                    [columns]="importedColumns$ | async"
                    [data]="imported"
                    [emptyDataTemplate]="nothingToImport"></app-table>
            <ng-template #nothingToImport>
                {{t('No files notification (import summary step) - None of files has been imported')}}
            </ng-template>
        </div>
    </div>

</div>

<div class="col-12 col-lg-4 col-md-4 pt-2 pb-2 ps-0 pe-0">
    <h3 class="title-heading-text">{{t('Unimported files title (import summary step) - Unimported files')}}</h3>

    <div class="col-12 col-lg-12 col-md-12 p-0">
        <div class="table-responsive minHeightForTable">
            <app-table
                    [columns]="unimportedColumns$ | async"
                    [data]="unimported"
                    [emptyDataTemplate]="nothingToImportFailure"></app-table>
            <ng-template #nothingToImportFailure>
                {{ t('All files imported notification (import summary step) - All files has been imported') }}
            </ng-template>
        </div>
    </div>
</div>
</ng-container>